import { createUseMutation } from 'api/common/createUseMutation'
import { submitUploadResource } from 'api/fetchers/marketing-capabilities/resources/upload/submitUploadResource'
import { useToast } from 'utils/toast'

export const useSubmitUploadResource = (onSuccess?: () => void) => {
  const { showToast } = useToast()

  return createUseMutation({
    fetcher: submitUploadResource,
    onSettled: (data, error) => {
      if (error) {
        showToast({
          type: 'error',
          message: 'Oops! Something went wrong when submitting the file, please try again.',
        })
        return
      }
      showToast({
        type: 'success',
        message: 'Resource successfully submitted to review.',
      })
      onSuccess?.()
    },
  })()
}
